
<template>
  <!--同步操作日志-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="taskId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="true"
    >
      <template slot="opt_f" slot-scope="{row}">
          <span style="color: rgb(24,144,255);cursor: pointer;" @click="checkDescCode(row)">{{row.deviceSncode}}</span>
      </template>
      <template slot="opt_o" slot-scope="{row}">
        <a-tooltip>
          <p slot="title">{{row.context}}</p>
          <p class="content">{{row.context}}</p>
        </a-tooltip>
      </template>

<!--      <template slot="opt_t" slot-scope="{row}">-->
<!--        <a-tooltip>-->
<!--          <p slot="title">{{row.message}}</p>-->
<!--          <p class="message">{{row.message}}</p>-->
<!--        </a-tooltip>-->
<!--      </template>-->
    </x-tabula>

    <!-- 查看详情的弹窗-->
    <a-modal v-model="visible" :title="title" :footer="null">
      <div v-if="isContent">
        <div class="model-wrap">
          <span>{{content}}</span>
        </div>
      </div>

      <div v-else>
        <div class="model-wrap">
          <span class="model-tips">设备编码：</span>
          <span>{{currentObj.deviceCode}}</span>
        </div>
        <div class="model-wrap">
          <span class="model-tips">设备名称：</span>
          <span>{{currentObj.deviceName}}</span>
        </div>
        <div class="model-wrap">
          <span class="model-tips">安装位置：</span>
          <span>{{currentObj.positionName}}</span>
        </div>
        <div style="text-align: right;">
          <a-button type="primary" :disabled="!currentObj.deviceId" @click="goToDoorDetail">查看详情</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { empty } from 'ant-design-vue-admin-x';
import {fetchSelect} from '@/utils/mixins';
export default {
  name: 'syncOptLog',
  mixins: [fetchSelect],
  data () {
    return {
      visible: false,
      title: '查看内容',
      isContent: true, // a-modal，true:展示设备编码，false：展示详情
      content: '',
      currentObj: {},
      searchList: [
        { props: ['deviceSncode'], placeholder: '设备编码', options: [], inputType: 'input' },
        { props: ['msgType'], placeholder: '操作类型', options: [], inputType: 'input' },
        { props: ['remark'], placeholder: '备注', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: [], inputType: 'select' },
        { props: ['createDate'], placeholder: ['开始时间', '结束时间'], options: [], inputType: 'datePick' },
        { props: ['mobile'], placeholder: '请输入手机号', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '重发日志', icon: 'sync', handle: this.batchSendLog, permi: ['community:devicetasks:resend'] }
      ],
      rowOptList: [
        { text: '重发日志', handle: row => this.sendLog(row.taskId), rowOptDisHandle: row => row.canRepeat === 0, permi: ['community:devicetasks:resend'] },
        { text: '查看', handle: row => this.checkContent(row), permi: ['community:devicetasks:device'] }
      ],
      columns: [
        { title: '手机号', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '设备编码', dataIndex: 'deviceSncode', align: 'left', width: '', scopedSlots: {customRender: 'f'} },
        { title: '操作类型', dataIndex: 'msgType', align: 'left', width: '' },
        // { title: '内容', dataIndex: 'context', align: 'left', width: '', scopedSlots: {customRender: 'o'} },
        { title: '备注', dataIndex: 'remark', align: 'left', width: undefined },
        // { title: '返回信息', dataIndex: 'message', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '处理时间', dataIndex: 'handleTime', align: 'left', width: undefined },
        { title: '发送次数', dataIndex: 'sendTimes', align: 'left', width: undefined },
        { title: '更新时间', dataIndex: 'updateTime', align: 'left', width: undefined },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: undefined },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: 80 },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        deviceSncode: undefined,
        msgType: undefined,
        remark: undefined,
        status: undefined,
        createDate: undefined,
        mobile: undefined
      },
      listApi: {
        url: '/syncTask/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {},
      deleteParam: {}
    };
  },
  created () {
    this.dictionarySelect([{index: 3, scope: 'searchList', query: 'comu_tasks_log_status'}]);
    let snCode = this.$route.query.id;
    if (snCode) {
      this.searchParams.deviceSncode = snCode;
      this.$nextTick(() => {
        empty.$emit('setSearchValue', {
          deviceSncode: this.searchParams.deviceSncode
        });
      });
    }
  },
  methods: {
    /** 批量重复发送日志 */
    batchSendLog (ids, rows) {
      let hasCanrepeat = rows.some((el) => {
        return el.canRepeat === 1;
      });
      let taskIds = [];
      for (let item of rows) {
        if (item.canRepeat === 1) {
          taskIds.push(item.taskId);
        }
      }
      if (!ids.length) {
        this.$message.error('请勾选需重发的设备');
        return;
      }
      if (!hasCanrepeat) {
        this.$message.error('没有可重发的设备');
        return;
      }

      this.$confirm({
        title: `已选择${ids.length}台设备，可重发${taskIds.length}台设备`,
        centered: true,
        onOk: (close) => {
          close();
          this.sendLog(taskIds);
        }
      });
    },
    /** 重复发送日志 */
    sendLog (taskIds) {
      if (Array.isArray(taskIds)) {
        taskIds = taskIds.join(',');
      }
      this.$get({
        url: `/syncTask/resend/${taskIds}`,
        params: {}
      }).then(({data}) => {
        this.$message.success('重发成功');
        this.$refs.table.getTableList();
      });
    },

    /** 展示设备编码详情 */
    checkDescCode (row) {
      this.$get({
        url: '/device/getInfo',
        params: { deviceCode: row.deviceSncode }
      }).then(({ data }) => {
        this.isContent = false;
        this.title = '查看设备';
        this.visible = true;
        this.currentObj = data;
      });
    },
    /** 展示同步日志详情 */
    checkContent (row) {
      this.isContent = true;
      this.title = '查看内容';
      this.visible = true;
      this.content = row.context;
    },
    goToDoorDetail () {
      this.visible = false;
      this.$router.push({
        name: 'smartDoorDetail',
        query: { id: this.currentObj.deviceId, ...this.breadParam(this) }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss">
  @import "../../style/variable";
  .content {
    @include over-txt(170px);
  }
  .message {
    @include over-txt(100px)
  }
  .model-wrap{
    margin-bottom: 16px;
    .model-tips{
      color: #000;
      margin-right: 30px;
    }
  }
</style>
